<div class="row features">
  <article id="content">
    <header>
      <h2>Birth Preparation Classes</h2>
    </header>
    <img class="image right img" src="assets/images/pregnant_women_together_1.jpg" alt="" />
    <p>Come learn about labor, birth, breastfeeding, infant care, and postpartum care. Explore the labyrinth of
      childbirth while learning coping techniques and thoughtful use of available tools.</p>
    <p>Equip yourself for the early days of caring for your infant and your growing family with evidence-based
      information grounded in a foundation of respect for birth as a natural, transformative process.</p>
    <p>Together we will discuss:</p>
    <ul>
      <li>How birth works, physically</li>
      <li>Movement that helps your baby and you set everything up for a healthy birth</li>
      <li>Coping with discomfort and making decisions about pain relief tools</li>
      <li>Complications and solutions</li>
      <li>Early infant care</li>
      <li>Breastfeeding</li>
      <li>Informed consent </li>
      <li>Other topics that come up as we work together</li>
    </ul>
    <img class="image left img" src="assets/images/MelissaAndDarcy.png" alt="" />
    <p>I am proud to partner with Melissa Navarro of GROW Midwifery to share these classes with our community.</p>
    <p>Melissa Navarro LM is a licensed midwife in the state of California and the principal at <a
        href="https://www.growmidwifery.org" target="_new">GROW Midwifery</a>.</p>
    <div style="
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    width: 259px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: -2px 10px 5px rgba(0, 0, 0, 0);
    border-radius: 10px;
    font-family: SQ Market, SQ Market, Helvetica, Arial, sans-serif;
    ">
      <img
        src="https://items-images-production.s3.us-west-2.amazonaws.com/files/257d7afe68d49d4568fcd14ce9fca830f5cfe4c5/original.png"
        alt="Grow and Daylily Birth Prep Class Registration" onerror="this.style.display='none'" style="width: 100%;">
      <div style="padding: 20px;">
        <p style="
      font-size: 18px;
      line-height: 20px;
    ">Classes Available for Fall, 2024</p>
        <a target="_blank" href="https://square.link/u/q1a07IVK?src=embed" style="
      display: inline-block;
      font-size: 18px;
      line-height: 48px;
      height: 48px;
      color: #ffffff;
      min-width: 212px;
      background-color: #006aff;
      text-align: center;
      box-shadow: 0 0 0 1px rgba(0,0,0,.1) inset;
      border-radius: 6px;
    ">Register Now</a>
      </div>
    </div>
  </article>
</div>